import { z } from 'zod'

/** TC-SPW3-15 / Figma forgot-password validation copy */
export const FORGOT_PW_INVALID_EMAIL_MSG = 'Enter a valid email address'

/** Aligns with Sensemaker forgot-password rate-limit copy (AC9). */
export const FORGOT_PW_RATE_LIMIT_MSG =
  'Please wait 5 minutes before requesting again.'

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email(FORGOT_PW_INVALID_EMAIL_MSG),
})

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>
